// @flow
import styled, { css } from 'styled-components';

import { lighten } from 'polished';
import DeviceIcon from '~/core/icons/device-icon';
import Icon from '~/core/icons';

const padding = '0.7em';
const nextStepWidth = '2.5em';
const iconSize = '2.5em';

export const Main = styled.div`
    border-bottom: 1px solid ${p => p.theme.offlineGrey};
    cursor: pointer;
    display: flex;
    flex-wrap: nowrap;
    justify-content: flex-start;
    padding: ${padding};
    position: relative;

    &:first-of-type {
        border-top: 1px solid ${p => p.theme.offlineGrey};
    }

    &:hover {
        background-color: ${p => lighten(0.3, p.theme.offlineGrey)};
    }
`;

const commonStyle = css`
    align-items: center;
    display: flex;
    justify-content: center;
    width: auto;
`;

export const Icons = styled.div`
    ${commonStyle} margin-left: ${padding};
    transition: all 0.2s ease-in-out;
`;

export const Description = styled.div`
    ${commonStyle} flex-grow: 2;
    justify-content: flex-start;
    margin-left: calc(${padding} * 1.5);

    p {
        margin: 0;
        padding: 0 calc(${padding} * 0.5);
        text-align: left;
    }
`;

export const NextStep = styled.div`
    align-items: center;
    display: flex;
    width: ${nextStepWidth};
`;

export const StyledDeviceIcon = styled(DeviceIcon)`
    font-size: ${iconSize};
    color: ${p => (p.active ? p.theme.mainBrandColor : p.theme.primaryFontColor)};
`;

export const StyledIcon = styled(Icon)`
    font-size: ${iconSize};
    color: ${p => (p.active ? p.theme.mainBrandColor : p.theme.primaryFontColor)};
`;



// WEBPACK FOOTER //
// ./src/components/widgets/recipes/template/style.js